/*
 * amondz Cart Interactions (v1.7)
 *
 * v1.7 변경: 수량 +/− 는 새로고침 없이 바뀐 영역만 교체(실패 시 새로고침). 삭제·쿠폰·포인트는 그대로
 *
 * v1.6 변경: 일부 선택 시 선택 합계 표시(정액 주문 할인=전체 값, 그 외=줄 몫), 불변식 검사,
 *   결제 진행 중 잠금, 세트/부속·부모 줄 체크 해제 불가, 금액 형식은 Shopify 샘플에서
 *   결제 시 뺀 미선택 상품은 돌아오면 다시 담김(azCoupon.saveKept/restoreKept)
 *
 * v1.5 변경 (쿠폰 적용·교체 UX):
 * - 쿠폰 적용 결과 해석을 공용 모듈 az-coupon.js(azCoupon.resolve)로 이관
 *   · 병용 불가 시 Shopify 판정(유리한 쪽)을 따르고 결과를 안내: 切り替えました / 併用できないため適用中 + [切り替える] / 条件未達
 *   · 밀린 쿠폰은 카트에서 정리(숨은 채 남아 나중에 되살아나지 않게) — 포인트 코드가 있으면 손대지 않음
 * - 개별 해제·포인트 취소를 /cart/update.js {discount:'A,B'} 목록 지정으로 교체(리다이렉트 체인 제거)
 * - 뒤로가기(BFCache) 복원 시 카트가 바뀌었으면 리로드
 *
 * v1.4 변경 (Shopify Markets 다중 통화 대응):
 * - currencyFormatter / formatMoney 제거
 *   - JPY 하드코딩이라 EUR 등 다른 통화에서 ¥로 잘못 표시되는 버그
 * - sticky 합계는 Liquid가 그린 cart.total_price | money_with_currency 그대로 유지
 *   - Markets 클라이언트 컨버터가 알아서 환산
 * - data-final-price 기반 선택 합산 로직 제거
 *   - data-final-price는 shop currency(JPY) cents라 다중 통화 환산 불가
 *   - sticky 합계는 "카트 전체" 기준으로 고정 (명세서와 동일 기준)
 * - 체크박스 선택/해제는 결제 시 미체크 상품 제거에만 영향 (UX 그대로)
 *
 * 이전 변경 이력:
 * - v1.3: BOGOS hijack 방어 코드 제거 (앱 삭제됨)
 * - v1.2.5: BFCache 복원 시 스피너 무한 회전 수정
 * - v1.2.4: 결제 버튼 자체 스피너 주입 (.az-checkout-spinner)
 * - v1.2.3: 선택 0개 시 명세서 영역 숨김
 * - v1.1: localStorage 제거, default 전체 선택, confirm 모달 제거
 *
 * 책임:
 * - 체크박스 (전체선택 / 개별선택 동기화)
 * - 선택 삭제
 * - 수량 변경 (AJAX /cart/change.js)
 * - 개별 삭제
 * - 쿠폰 적용 / 해제
 * - sticky 푸터: 선택 개수 갱신, 체크아웃 버튼 disabled 상태
 *   (합계는 Liquid가 카트 전체 기준으로 그린 값 유지)
 * - 결제 진행 (미체크 상품은 카트에서 제거 후 /checkout)
 */

(function() {
  'use strict';

  var LOG_PREFIX = '[az-cart]';
  function log() {
    try { console.log.apply(console, [LOG_PREFIX].concat([].slice.call(arguments))); } catch(e){}
  }

  var root = document.querySelector('[data-az-cart]');
  if (!root) return;

  var stickyForm = document.querySelector('[data-az-sticky-footer]');
  var stickyCount = document.querySelector('[data-az-sticky-count]');
  var stickyHint = document.querySelector('[data-az-sticky-hint]');
  var checkoutBtn = document.querySelector('[data-az-checkout]');
  // 주의: stickyTotal은 더 이상 JS가 갱신하지 않음 (Markets 환산 위해 Liquid 출력 유지)

  var selectAllInput = root.querySelector('[data-az-select-all]');
  var selectedCountEl = root.querySelector('[data-az-selected-count]');
  var deleteSelectedBtn = root.querySelector('[data-az-delete-selected]');

  // ============================================================
  // 상수
  // ============================================================
  // 결제 버튼 원래 내용(~~정가~~ 금액 + 문구 마크업) — 스피너 후 복원용
  var CHECKOUT_HTML = checkoutBtn ? checkoutBtn.innerHTML : '';
  // 문구는 snippets/az-i18n.liquid(window.azT)에서. 문구 조각이 없는 페이지(빈 장바구니)에서는 빈 문자열
  function azT(key, vars) { return window.azT ? window.azT(key, vars) : ''; }
  var CHECKOUT_LOADING_TEXT = azT('checkoutLoading');
  var CHECKOUT_LOADING_HTML = '<span class="az-checkout-spinner" aria-hidden="true"></span>' + CHECKOUT_LOADING_TEXT;

  // 포인트 동기화 상태 (아래 "포인트 적용 감지" 섹션에서 사용)
  // pointReloading: 우리가 navigate/reload를 시작했음 → 그동안 포인트 동기화 억제
  var pointPolling = false;
  var couponResolving = false;  // 쿠폰 시도 결과 해석(probe 포함) 중 → 결제 버튼 잠금
  var pointReloading = false;
  var pointBaselineSig = null;
  var pointBaselineCount = null;  // 로드 시점 상품 수 (뒤로가기 복원 시 비교)
  var pointSeenPointCodes = {};  // 로드 시점에 이미 있던 VIP-POINT 코드(새 실패 코드만 감지하기 위함)
  var pointBaselineCoupons = [];  // 로드 시점에 적용 중이던 쿠폰 코드(포인트가 밀어냈는지 감지용)
  var POINT_COUPON_KNOCKED_KEY = 'az_coupon_knocked';  // 포인트 적용으로 해제된 쿠폰 코드(리로드 후 안내용)

  function getCurrentSelected() {
    return [].slice.call(root.querySelectorAll('[data-az-select-item]:checked'))
      .map(function(input) { return input.getAttribute('data-key'); });
  }

  // ============================================================
  // 측정 이벤트 (az_*) — 쿠폰 토글 사용률·주문 전환 측정용
  // - Shopify.analytics.publish: 관리자 「고객 이벤트」 맞춤 픽셀에서 analytics.subscribe('az_…') 로 받아 GA4 로 전달
  // - dataLayer.push: 테마에 GTM 이 들어오면 그대로 사용(현재 라이브에는 GTM 없음)
  // - 개인정보·쿠폰 코드·상품 ID 는 넣지 않음. 금액은 통화 기본 단위(¥)
  // ============================================================
  var TRACK_TOGGLE_KEY = 'az_track_toggle';
  var TRACK_ITEM_KEY = 'az_track_item_toggle';
  // 쿠폰 개별 적용/해제는 곧바로 리로드·이동 → 그 자리에서 보내면 픽셀 전송이 끊길 수 있어 저장했다가 다음 로드에서 보냄
  function trackItemLater(data) {
    try {
      var list = JSON.parse(sessionStorage.getItem(TRACK_ITEM_KEY) || '[]');
      list.push(Object.assign({ t: Date.now() }, data));
      sessionStorage.setItem(TRACK_ITEM_KEY, JSON.stringify(list.slice(-5)));
    } catch (e) { track('az_coupon_item_toggle', data); }  // 저장 불가(사파리 개인 모드 등) → 바로 보냄
  }
  function track(name, data) {
    var payload = Object.assign({
      device: window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || ''
    }, data);
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload); } catch (e) {}
    log('track', name, payload);
  }
  function trackState() {
    var footer = document.querySelector('[data-az-footer]');
    var toggle = document.querySelector('[data-az-best-toggle]');
    var coupon = 0;
    document.querySelectorAll('[data-detail-key]').forEach(function(l) { coupon += Number(l.getAttribute('data-coupon')) || 0; });
    document.querySelectorAll('[data-detail-fixed][data-kind="coupon"]').forEach(function(l) { coupon += Number(l.getAttribute('data-detail-fixed')) || 0; });
    var cands = toggle ? String(toggle.getAttribute('data-candidates') || '').split(',').filter(function(c) { return c.trim(); }).length : 0;
    return {
      toggle_state: toggle ? (toggle.getAttribute('aria-checked') === 'true' ? 'on' : 'off') : 'none',
      available_coupon_count: cands,
      applied_coupon_count: document.querySelectorAll('.az-coupon__applied[data-az-applied-type="discount_code"]').length,
      cart_total: footer ? (Number(footer.getAttribute('data-cart-total')) || 0) / 100 : null,
      coupon_discount: coupon / 100
    };
  }
  function trackCouponKind(code) {
    var toggle = document.querySelector('[data-az-best-toggle]');
    var cands = String(toggle && toggle.getAttribute('data-candidates') || '').toLowerCase().split(',');
    return cands.indexOf(String(code || '').toLowerCase()) !== -1 ? 'campaign' : 'manual';
  }
  function trackPageLoad() {
    var s = trackState();
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    track('az_cart_view', {
      available_coupon_count: s.available_coupon_count,
      toggle_state: s.toggle_state,
      nav_type: nav ? nav.type : ''  // reload = 쿠폰·수량 변경 뒤 새로고침(분모 집계 시 제외)
    });
    // 토글 조작 결과는 리로드 뒤 서버 금액이 나와야 알 수 있음 → 클릭 때 저장한 값과 짝지어 보냄
    var pending = null;
    try { pending = JSON.parse(sessionStorage.getItem(TRACK_TOGGLE_KEY) || 'null'); sessionStorage.removeItem(TRACK_TOGGLE_KEY); } catch (e) {}
    if (pending && Date.now() - pending.t < 60000) {
      track('az_coupon_toggle', {
        state: pending.state,
        result_state: s.toggle_state,
        total_before: pending.total_before,
        total_after: s.cart_total,
        coupon_count_before: pending.coupon_count_before,
        coupon_count_after: s.applied_coupon_count
      });
    }
    var items = [];
    try { items = JSON.parse(sessionStorage.getItem(TRACK_ITEM_KEY) || '[]'); sessionStorage.removeItem(TRACK_ITEM_KEY); } catch (e) {}
    items.forEach(function(it) {
      if (Date.now() - it.t < 60000) track('az_coupon_item_toggle', { coupon_kind: it.coupon_kind, state: it.state });
    });
  }

  // ============================================================
  // BFCache 복원 시 스피너 원복
  // ============================================================
  // 뒤로가기 복원 화면은 떠날 때의 쿠폰·금액 그대로 → 그 사이 카트가 바뀌었으면(다른 페이지에서 쿠폰 적용 등) 다시 그림
  function checkStaleCart() {
    if (pointBaselineSig === null) return;
    pointFetchCart().then(function(cart) {
      // 금액이 같아도 줄이 빠졌을 수 있음(¥0 상품 등) → 상품 개수도 비교
      if (pointCartSig(cart) !== pointBaselineSig || cart.item_count !== pointBaselineCount) window.location.reload();
    }).catch(function() {});
  }

  if (checkoutBtn) {
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) {
        log('pageshow from bfcache, reset checkout button');
        // 쿠폰 적용/해제·결제로 떠나며 세운 플래그 해제 — 안 풀면 복원된 화면에서 쿠폰 버튼이 먹통
        couponBusy = false;
        pointReloading = false;
        couponResolving = false;
        setCouponLoading(false);
        checkoutBtn.innerHTML = CHECKOUT_HTML;
        setCheckoutLock(false);  // 내부에서 refreshSummary — 잠금을 먼저 풀어야 버튼이 비활성으로 남지 않음
        // 결제 화면에서 돌아옴 → 뺐던 미선택 상품 다시 담기 (담을 게 없었으면 아래 확인으로)
        if (restoreKeptThenReload(checkStaleCart)) return;
        checkStaleCart();
      }
    });
  }

  // ============================================================
  // refreshSummary
  // - 선택 개수 표시
  // - 체크아웃 버튼 disabled 상태
  // - 명세서 숨김 토글
  // - 전체선택 체크박스 상태 동기화
  // ※ sticky 합계는 갱신하지 않음 (Liquid가 그린 cart.total_price 유지)
  // ============================================================
  // ── 일부 선택 시 금액 = 선택한 상품 합계 ──
  // 줄별 실제 지불액(data-pay: 원가 − 쿠폰·자동할인·포인트 몫)은 서버 계산값 → 전 줄 합 = cart.total_price.
  // 상품 단위 할인은 정확, 주문 쿠폰·포인트는 결제 때 남은 상품 기준으로 재계산될 수 있어 안내를 덧붙임.
  // 금액 형식은 Shopify 가 그린 샘플 문자열(1,000,000 단위)에서 통화 기호·구분자를 따옴(다중 통화 원칙, JS 고정 통화 금지).
  function moneyFormatter(sample) {
    if (!sample) return null;
    sample = String(sample).replace(/<[^>]*>/g, '');  // 상점 금액 형식에 HTML(<span class=money>)이 있어도 텍스트만
    var m = sample.match(/1([^0-9]?)000(?:\1)000(?:([^0-9])00)?(?![0-9])/);
    if (!m) return null;  // 해석 불가 형식(소수 3자리 등) → 재계산 안 함
    var prefix = sample.slice(0, m.index), suffix = sample.slice(m.index + m[0].length);
    if (/^[^0-9]?[0-9]/.test(suffix)) return null;  // 숫자가 더 이어짐(소수 3자리 통화 등) → 해석 불가로 보고 재계산 안 함
    var thou = m[1] || '', dec = m[2] || null;
    return function(subunits) {
      var neg = subunits < 0, v = Math.abs(subunits) / 100;
      var intPart, frac = '';
      if (dec) { var f = v.toFixed(2).split('.'); intPart = f[0]; frac = dec + f[1]; }
      else { intPart = String(Math.round(v)); }
      intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return (neg ? '-' : '') + prefix + intPart + frac + suffix;
    };
  }

  var selectionOriginal = null;  // 서버가 그린 전체 기준 금액(전체 선택으로 돌아오면 복원)
  function updateSelectionTotals(selectedKeys, partial) {
    var footerEl = document.querySelector('[data-az-footer]');
    if (!footerEl) return false;
    var els = {
      ctaTotal: footerEl.querySelector('[data-az-sticky-total]'),
      ctaRef: footerEl.querySelector('[data-az-cta-ref]'),
      headTotal: footerEl.querySelector('[data-az-purchase-total]'),
      headRef: footerEl.querySelector('[data-az-purchase-ref]'),
      original: footerEl.querySelector('[data-az-purchase-original]'),
      note: footerEl.querySelector('[data-az-sheet-partial]')
    };
    // 원래(전체 기준) 금액은 처음 일부 선택이 되는 순간에 저장 — 로드 후 통화 변환 앱이 바꾼 값까지 보존
    if (partial && !selectionOriginal) {
      selectionOriginal = {};
      ['ctaTotal', 'ctaRef', 'headTotal', 'headRef', 'original'].forEach(function(k) {
        if (els[k]) selectionOriginal[k] = { text: els[k].textContent, hidden: els[k].hidden };
      });
    }
    function restore() {
      if (!selectionOriginal) return;
      Object.keys(selectionOriginal).forEach(function(k) {
        if (!els[k]) return;
        els[k].textContent = selectionOriginal[k].text;
        els[k].hidden = selectionOriginal[k].hidden;
      });
      if (els.note) els.note.hidden = true;
    }
    if (!partial) { restore(); return false; }

    var fmt = moneyFormatter(footerEl.getAttribute('data-money-sample'));
    var fmtCur = moneyFormatter(footerEl.getAttribute('data-money-sample-cur')) || fmt;
    if (!fmt) { restore(); return false; }
    // 불변식: 줄 지불액 합 = Shopify 장바구니 합계. 깨지면(예상 못 한 할인 구조) 선택 합계를 믿을 수 없으니 쓰지 않음
    if (footerEl.getAttribute('data-pay-sum') !== footerEl.getAttribute('data-cart-total')) {
      log('selection total disabled: pay-sum != cart-total');
      restore();
      return false;
    }

    var sumRef = 0, sumPay = 0;
    [].slice.call(root.querySelectorAll('[data-az-item]')).forEach(function(item) {
      if (selectedKeys.indexOf(item.getAttribute('data-key')) === -1) return;
      var a = item.querySelector('[data-az-line-amounts]');
      if (!a) return;
      sumRef += parseInt(a.getAttribute('data-ref'), 10) || 0;
      sumPay += parseInt(a.getAttribute('data-pay'), 10) || 0;
    });
    // 정액 주문 할인(포인트·정액 주문 쿠폰)은 남은 상품 전체에 그대로 적용 → 전체 값을 한 번 뺌(선택 금액보다 크면 그 금액까지)
    var fixedOrder = parseInt(footerEl.getAttribute('data-fixed-order'), 10) || 0;
    sumPay = sumPay - Math.min(fixedOrder, sumPay);
    if (els.ctaTotal) els.ctaTotal.textContent = fmtCur(sumPay);
    if (els.headTotal) els.headTotal.textContent = fmt(sumPay);
    if (els.original) els.original.textContent = fmt(sumRef);
    [els.ctaRef, els.headRef].forEach(function(el) {
      if (!el) return;
      el.textContent = fmt(sumRef);
      el.hidden = !(sumRef > sumPay);
    });
    if (els.note) els.note.hidden = false;
    return true;
  }

  function refreshSelectedDetails(selected) {
    var footer = document.querySelector('[data-az-footer]');
    if (!footer || footer.getAttribute('data-pay-sum') !== footer.getAttribute('data-cart-total')) return;
    var fmt = moneyFormatter(footer.getAttribute('data-money-sample'));
    if (!fmt) return;
    var totals = {product:0, coupon:0, point:0};
    document.querySelectorAll('[data-detail-key]').forEach(function(line) {
      if (selected.indexOf(line.getAttribute('data-detail-key')) < 0) return;
      Object.keys(totals).forEach(function(kind) { totals[kind] += Number(line.getAttribute('data-' + kind)) || 0; });
    });
    // Fixed order discounts are deducted once in the selected total, matching the CTA.
    var fixedBudget = 0;
    root.querySelectorAll('[data-az-item]').forEach(function(item) {
      if (selected.indexOf(item.getAttribute('data-key')) < 0) return;
      var line = item.querySelector('[data-az-line-amounts]');
      if (line) fixedBudget += Number(line.getAttribute('data-pay')) || 0;
    });
    document.querySelectorAll('[data-detail-fixed]').forEach(function(line) {
      var share = Math.min(fixedBudget, Number(line.getAttribute('data-detail-fixed')) || 0);
      totals[line.getAttribute('data-kind')] += share;
      fixedBudget -= share;
    });
    document.querySelectorAll('[data-az-detail-total]').forEach(function(el) {
      var amount = totals[el.getAttribute('data-az-detail-total')];
      el.textContent = amount > 0 ? '−' + fmt(amount) : fmt(0);
      el.classList.toggle('az-purchase-detail__value--discount', amount > 0);
      el.classList.toggle('az-purchase-detail__value--muted', amount === 0);
    });
    var orderAmounts = {};
    document.querySelectorAll('[data-detail-coupon-key]').forEach(function(row) {
      row.hidden = selected.indexOf(row.getAttribute('data-detail-coupon-key')) < 0;
      if (!row.hidden) {
        var title = row.getAttribute('data-detail-title');
        orderAmounts[title] = (orderAmounts[title] || 0) + Number(row.getAttribute('data-detail-share'));
      }
    });
    document.querySelectorAll('[data-detail-order]').forEach(function(row) {
      var amount = Number(row.getAttribute('data-detail-fixed-order')) || orderAmounts[row.getAttribute('data-detail-order')] || 0;
      row.hidden = !selected.length || !amount;
      var value = row.querySelector('.az-purchase-detail__coupon-amount');
      if (value) value.textContent = '−' + fmt(Math.min(amount, totals.coupon));
    });
    var compact = document.querySelector('.az-compact-summary');
    if (compact) {
      var footer = document.querySelector('[data-az-footer]');
      var displayed = footer && footer.querySelector('[data-az-sticky-total]');
      var discount = totals.coupon + totals.point;
      var pay = 0;
      var compactRef = 0;
      root.querySelectorAll('[data-az-item]').forEach(function(item) {
        if (selected.indexOf(item.getAttribute('data-key')) < 0) return;
        var amounts = item.querySelector('[data-az-line-amounts]');
        if (amounts) {
          pay += Number(amounts.getAttribute('data-pay')) || 0;
          compactRef += Number(amounts.getAttribute('data-ref')) || 0;
        }
      });
      pay = Math.max(0, pay - (Number(footer && footer.getAttribute('data-fixed-order')) || 0));
      compact.querySelector('[data-az-compact-total]').textContent = displayed ? displayed.textContent : fmt(pay);
      compact.querySelector('[data-az-compact-subtotal]').textContent = fmt(compactRef);
      var productDiscount = Math.max(0, compactRef - pay - discount);
      compact.querySelector('[data-az-compact-product]').textContent = '−' + fmt(productDiscount);
      // 쿠폰 할인과 포인트 사용은 따로 표시. 총 할인 = 상품할인 + 쿠폰 할인(포인트 제외)
      compact.querySelector('[data-az-compact-discount]').textContent = '−' + fmt(totals.coupon);
      var pointRowEl = compact.querySelector('[data-az-compact-point-row]');
      if (pointRowEl) {
        pointRowEl.hidden = totals.point <= 0;
        pointRowEl.querySelector('[data-az-compact-point]').textContent = '−' + fmt(totals.point);
      }
      var totalDiscount = productDiscount + totals.coupon;
      var saving = compact.querySelector('[data-az-compact-saving]');
      saving.hidden = totalDiscount <= 0;
      saving.textContent = saving.getAttribute('data-template').replace('%amount%', fmt(totalDiscount));
    }
    var designPoint = document.querySelector('[data-az-design-point]');
    if (designPoint) {
      designPoint.hidden = totals.point <= 0;
      designPoint.querySelector('[data-az-design-point-value]').textContent = '−' + Math.round(totals.point / 100).toLocaleString(document.documentElement.lang || 'ja-JP') + 'pt';
    }
    document.querySelectorAll('[data-az-design-coupon-key]').forEach(function(row) {
      row.hidden = selected.indexOf(row.getAttribute('data-az-design-coupon-key')) < 0;
    });
    var designCoupons = document.querySelector('[data-az-design-coupon-panel]');
    if (designCoupons) designCoupons.hidden = totals.coupon <= 0;
    var pointRow = document.querySelector('[data-az-point-row]');
    if (pointRow) pointRow.hidden = totals.point === 0;
    var pointPreview = document.querySelector('[data-vip-applied-amount]');
    if (pointPreview) {
      pointPreview.hidden = totals.point <= 0;
      pointPreview.querySelector('[data-vip-applied-value]').textContent = '−' + Math.round(totals.point / 100).toLocaleString(document.documentElement.lang || 'ja-JP') + 'pt';
    }
    // Match benefit labels to the actual cart product label by cart line key.
    var displayedProductNames = {};
    document.querySelectorAll('[data-az-item][data-key]').forEach(function(item) {
      var label = item.querySelector('.az-product__name');
      if (label) displayedProductNames[item.getAttribute('data-key')] = label.textContent.trim();
    });
    function couponProductName(row) {
      return displayedProductNames[row.getAttribute('data-detail-coupon-key')] || '';
    }
    document.querySelectorAll('[data-detail-coupon-key]').forEach(function(row) {
      var label = row.querySelector('.az-purchase-detail__coupon-name');
      var title = couponProductName(row);
      if (label && title) { label.textContent = title; label.setAttribute('translate', 'no'); }
    });
    var activeCodes = 0;
    document.querySelectorAll('[data-az-applied-code]').forEach(function(row) {
      var code = row.getAttribute('data-az-applied-code');
      var amount = orderAmounts[code] || 0;
      var orderRow = Array.from(document.querySelectorAll('[data-detail-order]')).find(function(r) { return r.getAttribute('data-detail-order') === code; });
      if (orderRow && selected.length) amount = Number(orderRow.getAttribute('data-detail-fixed-order')) || amount;
      row.hidden = !amount;
      if (amount) activeCodes++;
      var value = row.querySelector('.az-coupon__applied-amount');
      if (value) value.textContent = '−' + fmt(Math.min(amount, totals.coupon));
      var names = Array.from(document.querySelectorAll('[data-detail-coupon-key]')).filter(function(r) {
        return !r.hidden && r.getAttribute('data-detail-title') === code;
      }).map(function(r) { return couponProductName(r); });
      var target = row.querySelector('.az-coupon__applied-target');
      if (target && names.length) {
        target.textContent = '';
        Array.from(document.querySelectorAll('[data-detail-coupon-key]')).filter(function(r) {
          return !r.hidden && r.getAttribute('data-detail-title') === code;
        }).forEach(function(r) {
          var line = document.createElement('div');
          line.className = 'az-coupon__target-line';
          var name = document.createElement('span');
          name.textContent = couponProductName(r);
          name.setAttribute('translate', 'no');
          name.setAttribute('data-az-product-name-key', r.getAttribute('data-detail-coupon-key'));
          var discount = document.createElement('span');
          discount.textContent = '−' + fmt(Number(r.getAttribute('data-detail-share')) || 0);
          line.appendChild(name); line.appendChild(discount); target.appendChild(line);
        });
      }
    });
    var countEl = document.querySelector('[data-az-selected-coupon-count]');
    if (countEl) countEl.textContent = activeCodes ? countEl.getAttribute('data-count-text').replace('%count%',activeCodes) : countEl.getAttribute('data-none-text');
    var estimated = document.querySelector('.az-purchase-detail__estimated');
    if (estimated) estimated.hidden = selected.length !== root.querySelectorAll('[data-az-select-item]').length;
    var summaryAmount = document.querySelector('.az-coupon__summary-amount');
    if (summaryAmount) summaryAmount.textContent = '−' + fmt(totals.coupon);
    // 하단 「合計」 토글도 같은 속성을 쓰므로 쿠폰 요약 버튼만 집는다(쿠폰 0이어도 合計는 항상 보임)
    var couponSummary = document.querySelector('.az-coupon__summary[data-az-discount-toggle]');
    if (couponSummary) {
      couponSummary.hidden = totals.coupon <= 0;
      if (couponSummary.hidden) {
        couponSummary.setAttribute('aria-expanded', 'false');
        var couponList = document.getElementById('az-coupon-applied');
        if (couponList) couponList.hidden = true;
      }
    }
    var desc = document.querySelector('[data-az-selected-coupon-desc]');
    if (desc) {
      var count = 0, selectedQuantity = 0;
      root.querySelectorAll('[data-az-item]').forEach(function(item) {
        if (!selected.includes(item.getAttribute('data-key'))) return;
        var amounts = item.querySelector('[data-az-line-amounts]');
        var quantity = amounts ? Number(amounts.getAttribute('data-qty')) || 0 : 0;
        selectedQuantity += quantity;
        var detail = Array.from(document.querySelectorAll('[data-detail-key]')).find(function(line) {
          return line.getAttribute('data-detail-key') === item.getAttribute('data-key');
        });
        if (detail && Number(detail.getAttribute('data-coupon')) > 0) count += quantity;
      });
      desc.textContent = count ? desc.getAttribute('data-count-text').replace('%count%', count).replace('%total%', selectedQuantity) : desc.getAttribute('data-none-text');
    }
  }

  var shippingTimer, shippingController, shippingVersion = 0, shippingSignature = '';
  var shippingCache = new Map();
  function requestShipping(selected) {
    var signature = selected.slice().sort().join('|');
    var status = document.querySelector('[data-az-shipping-status]');
    if (!status || !window.azShippingApi || status.getAttribute('data-country') !== 'JP') return;
    var cached = shippingCache.get(signature);
    function display(result) {
      // lookup 이 non-null = 일반(도쿄)·원격(나하) 두 요금 지역 모두 배송 할인으로 무료 확인 → 금액 기준 문구보다 우선(정책: 무료배송 쿠폰은 전 지역 무료)
      if (!result) return;
      status.textContent = status.getAttribute(result.automatic ? 'data-automatic' : 'data-code-free');
      var detail = document.querySelector('[data-az-shipping-value]');
      if (detail) detail.textContent = status.textContent;
      status.setAttribute('data-shipping-source', 'shopify');
    }
    if (cached && Date.now() - cached.time < 60000) {
      ++shippingVersion; clearTimeout(shippingTimer);
      if (shippingController) shippingController.abort();
      shippingSignature = ''; display(cached.result); return;
    }
    if (shippingSignature === signature) return;
    shippingSignature = signature;
    var version = ++shippingVersion;
    clearTimeout(shippingTimer);
    if (shippingController) shippingController.abort();
    if (!selected.length) return;
    shippingTimer = setTimeout(async function() {
      var controller = new AbortController();
      shippingController = controller;
      var timeout = setTimeout(function() { controller.abort(); }, 12000);
      try {
        var response = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js',
          {headers:{'Accept':'application/json'}, signal:controller.signal});
        if (!response.ok) throw new Error('Cart unavailable');
        var cart = await response.json();
        var result = await window.azShippingApi.lookup(cart, selected, controller.signal);
        if (version !== shippingVersion || signature !== getCurrentSelected().slice().sort().join('|')) return;
        shippingCache.set(signature, {time:Date.now(), result:result});
        display(result);
      } catch (e) { /* Keep the existing amount policy if Shopify cannot calculate. */ }
      finally { clearTimeout(timeout); if (version === shippingVersion) shippingSignature = ''; }
    }, 250);
  }

  function refreshShipping(selected, partial) {
    var status = document.querySelector('[data-az-shipping-status]');
    if (!status) return;
    var footer = document.querySelector('[data-az-footer]');
    var detail = document.querySelector('[data-az-shipping-value]');
    var fallback = status.getAttribute('data-default');
    status.removeAttribute('data-shipping-source');
    status.textContent = fallback;
    if (detail) detail.textContent = fallback;
    if (!selected.length || status.getAttribute('data-currency') !== 'JPY' || !footer) return;
    var amount = Number(status.getAttribute('data-total'));
    if (partial) {
      if (footer.getAttribute('data-pay-sum') !== footer.getAttribute('data-cart-total')) return;
      amount = 0;
      [].slice.call(root.querySelectorAll('[data-az-item]')).forEach(function(item) {
        if (selected.indexOf(item.getAttribute('data-key')) === -1) return;
        var line = item.querySelector('[data-az-line-amounts]');
        if (line) amount += Number(line.getAttribute('data-pay')) || 0;
      });
      amount = Math.max(0, amount - (Number(footer.getAttribute('data-fixed-order')) || 0));
    }
    // 금액 기준 임시 안내. Shopify 계산(requestShipping)에서 배송 쿠폰이 확인되면 그 문구로 덮어쓴다.
    // 배송지 미확인: 일반 지역과 모든 일본 지역 기준을 구분한다.
    if (amount >= 1000000) {
      status.textContent = status.getAttribute('data-free');
      if (detail) detail.textContent = status.textContent;
    } else if (amount >= 500000) {
      status.textContent = status.getAttribute('data-general-free');
      if (detail) detail.textContent = status.textContent;
    } else {
      var fmt = moneyFormatter(footer.getAttribute('data-money-sample'));
      if (fmt) status.textContent = status.getAttribute('data-remaining').replace('%amount%', fmt(500000 - amount));
    }
  }

  function refreshSummary() {
    var selected = getCurrentSelected();
    var label = document.querySelector('[data-az-cta-label]');
    if (label) {
      var quantity = 0;
      root.querySelectorAll('[data-az-item]').forEach(function(item) {
        if (!selected.includes(item.getAttribute('data-key'))) return;
        var amounts = item.querySelector('[data-az-line-amounts]');
        if (amounts) quantity += Number(amounts.getAttribute('data-qty')) || 0;
      });
      label.textContent = label.getAttribute('data-count-template').replace('%count%',quantity);
    }

    if (selectedCountEl) selectedCountEl.textContent = selected.length;
    if (stickyCount) stickyCount.textContent = selected.length;

    if (checkoutBtn) {
      var disabled = selected.length === 0 || couponResolving || checkoutInFlight || qtyBusy;
      checkoutBtn.disabled = disabled;
      checkoutBtn.setAttribute('aria-disabled', String(disabled));
    }
    if (stickyHint) {
      stickyHint.hidden = selected.length > 0;
    }

    // 선택 합계는 유지하고, 할인 확정 안내만 표시한다.
    var totalCount = root.querySelectorAll('[data-az-select-item]').length;
    var partial = selected.length > 0 && selected.length < totalCount;
    var recalculated = updateSelectionTotals(selected, partial);
    refreshSelectedDetails(selected);
    refreshShipping(selected, partial);
    requestShipping(selected);
    var selHint = document.querySelector('[data-az-selection-hint]');
    if (selHint) {
      var footerEl = document.querySelector('[data-az-footer]');
      var showDiscountNote = partial && footerEl && footerEl.getAttribute('data-has-discounts') === 'true';
      selHint.textContent = selHint.getAttribute('data-order-note') || '';
      selHint.hidden = !showDiscountNote;
    }

    // 선택 0개일 때 명세서 숨김
    if (selected.length === 0) {
      root.setAttribute('data-az-cart-empty-selection', '');
    } else {
      root.removeAttribute('data-az-cart-empty-selection');
    }

    if (selectAllInput) {
      var totalItems = root.querySelectorAll('[data-az-select-item]').length;
      if (selected.length === 0) {
        selectAllInput.checked = false;
        selectAllInput.indeterminate = false;
      } else if (selected.length === totalItems) {
        selectAllInput.checked = true;
        selectAllInput.indeterminate = false;
      } else {
        selectAllInput.checked = false;
        selectAllInput.indeterminate = true;
      }
    }
  }

  // ============================================================
  // 명세서 割引金額 접기 토글 (기본 접힘)
  // ============================================================
  root.addEventListener('click', function(e) {
    var t = e.target.closest('[data-az-discount-toggle]');
    if (!t) return;
    var detail = document.getElementById(t.getAttribute('aria-controls'));
    if (!detail) return;
    var open = t.getAttribute('aria-expanded') !== 'true';
    t.setAttribute('aria-expanded', String(open));
    detail.hidden = !open;
  });

  // ============================================================
  // 이벤트: 체크박스
  // ============================================================
  root.addEventListener('change', function(e) {
    if (e.target.matches('[data-az-select-item]')) {
      refreshSummary();
    }
  });

  if (selectAllInput) {
    selectAllInput.addEventListener('change', function() {
      var checked = selectAllInput.checked;
      [].slice.call(root.querySelectorAll('[data-az-select-item]')).forEach(function(input) {
        if (!input.disabled) input.checked = checked;  // 세트/부속 줄은 항상 포함
      });
      refreshSummary();
    });
  }

  // ============================================================
  // 수량 변경 / 개별 삭제 (AJAX)
  // ============================================================

  function changeLineQuantity(key, quantity) {
    log('change qty', key, quantity);
    var item = root.querySelector('[data-az-item][data-key="' + key + '"]');
    if (item) item.classList.add('is-updating');
    forgetKept();  // 고객이 카트를 직접 바꿈 → 예전 결제 때 뺀 상품 기록은 버림(지운 상품이 되살아나지 않게)

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('change failed: ' + res.status);
      return res.json();
    })
    .then(function() {
      pointReloading = true;
      window.location.reload();
    })
    .catch(function(err) {
      log('change err', err);
      if (item) item.classList.remove('is-updating');
      alert(azT('alertQtyChangeFailed'));
    });
  }

  // ============================================================
  // 수량 +/− 빠른 반영 (v1.7) — 삭제·쿠폰·포인트 등 다른 경로는 기존 새로고침 그대로
  // - 누르면 숫자 즉시 변경. 응답 대기 중 추가 클릭은 마지막 수량으로 합쳐 1회 요청
  // - /cart/change.js 응답에 섹션 HTML 을 같이 받아 바뀐 영역만 교체(root 는 그대로 → 위임 리스너 유지)
  // - 체크 상태·쿠폰 입력칸·토글·열린 시트/접기·VIP 포인트 폼은 기존 요소를 그대로 둠
  // - 오류·응답 이상·요소 미발견·5초 초과 → 기존처럼 새로고침
  // ============================================================
  var QTY_TIMEOUT = 5000;
  var qtyTargets = {};  // 줄 key → 화면에 보이는 목표 수량(아직 안 보낸 것)
  var qtyBusy = false;
  var qtySectionId = ((root.closest('.shopify-section') || {}).id || '').replace(/^shopify-section-/, '');
  var qtyStartTotal = 0;  // 이번 수량 반영을 시작할 때의 장바구니 합계
  // 관세 안내 팝업(Promolayer 앱 「お知らせ」, 장바구니 합계 조건)은 페이지를 열 때만 판단한다 →
  // 합계가 기준 부근을 넘어 오르면 예전처럼 새로고침해 팝업이 뜨게 함.
  // 안내 기준 16,666円(税抜) ≈ 18,333円(税込). 앱 설정값은 테마가 읽을 수 없어 두 값 사이 전체를 기준 구간으로 봄(앱 설정을 바꾸면 여기도 맞출 것)
  var NOTICE_MIN = 1666600, NOTICE_MAX = 1833400;
  function qtyCrossesNotice(before, after) {
    return after > before && after >= NOTICE_MIN && before < NOTICE_MAX;
  }

  function qtyReload() {
    pointReloading = true;
    window.location.reload();
  }

  function setQtyDisplay(key, qty) {
    var item = root.querySelector('[data-az-item][data-key="' + key + '"]');
    if (!item) return;
    item.classList.add('is-updating');
    var value = item.querySelector('[data-az-qty-value]');
    if (value) value.textContent = qty;
    var down = item.querySelector('[data-az-qty-down]');
    if (down) down.disabled = qty <= 1;
  }

  // 새 섹션 HTML 에서 금액이 바뀌는 영역만 옮겨 담는다. 검사를 먼저 모두 끝내고 바꾸며, 어긋나면 throw → 새로고침
  function qtySwap(html) {
    if (!html) throw new Error('no section html');
    var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-az-cart]');
    if (!next) throw new Error('no cart root');
    function pick(scope, sel) {
      var el = scope.querySelector(sel);
      if (!el) throw new Error('missing ' + sel);
      return el;
    }
    function keys(scope) {
      return [].map.call(scope.querySelectorAll('[data-az-item]'), function(el) { return el.getAttribute('data-key'); }).join(',');
    }
    if (keys(next) !== keys(root)) throw new Error('line keys changed');
    var lines = [].map.call(root.querySelectorAll('[data-az-item]'), function(item) {
      var src = next.querySelector('[data-az-item][data-key="' + item.getAttribute('data-key') + '"]');
      return { item: item, src: src, info: pick(item, '.az-product__info'), nextInfo: pick(src, '.az-product__info') };
    });
    // 교체 영역 안에서도 기존 요소를 그대로 둘 곳(새 HTML 의 같은 자리에 옮겨 넣음)
    function keepIn(scope, nextScope, sels) {
      return sels.map(function(sel) {
        var o = scope.querySelector(sel), n = nextScope.querySelector(sel);
        if (!o !== !n) throw new Error('layout changed: ' + sel);
        return [o, n];
      });
    }
    var coupon = pick(root, '[data-az-coupon]'), nextCoupon = pick(next, '[data-az-coupon]');
    var footer = pick(root, '[data-az-footer]'), nextFooter = pick(next, '[data-az-footer]');
    var sheet = pick(footer, '#az-cart-sheet'), nextSheet = pick(nextFooter, '#az-cart-sheet');
    // 쿠폰: 토글(직접 리스너)·코드 입력(입력값·펼침)·안내 문구 / 시트: 적립 예정 줄(하단 스크립트가 로드 때 잡아 둔 요소)
    var keep = keepIn(coupon, nextCoupon, ['[data-az-best-toggle]', '[data-az-best-toggle-disabled]', '[data-az-best-note]', '.az-coupon__code', '[data-az-coupon-error]'])
      .concat(keepIn(sheet, nextSheet, ['[data-az-footer-earn]']));
    var ship = pick(footer, '[data-az-shipping-status]'), nextShip = pick(nextFooter, '[data-az-shipping-status]');
    var cta = pick(footer, '[data-az-checkout]'), nextCta = pick(nextFooter, '[data-az-checkout]');
    var title = pick(root, '.az-cart__title'), nextTitle = pick(next, '.az-cart__title');

    var open = [];  // 펼쳐 둔 접기 영역(쿠폰 적용 목록 등)
    root.querySelectorAll('[data-az-discount-toggle][aria-expanded="true"]').forEach(function(t) { open.push(t.getAttribute('aria-controls')); });
    var focused = document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-az-qty-up], [data-az-qty-down]');
    var focusSel = focused ? (focused.hasAttribute('data-az-qty-up') ? '[data-az-qty-up]' : '[data-az-qty-down]') : null;
    var focusKey = focused && focused.getAttribute('data-key');
    function copyData(from, to) {
      [].forEach.call(from.attributes, function(a) { if (a.name.indexOf('data-') === 0) to.setAttribute(a.name, a.value); });
    }

    lines.forEach(function(l) {
      l.info.replaceWith(l.nextInfo);
      l.item.setAttribute('data-final-price', l.src.getAttribute('data-final-price'));
      l.item.classList.remove('is-updating');
    });
    keep.forEach(function(k) { if (k[0]) k[1].replaceWith(k[0]); });
    coupon.replaceChildren.apply(coupon, [].slice.call(nextCoupon.childNodes));
    copyData(nextFooter, footer);
    copyData(nextShip, ship);
    sheet.replaceChildren.apply(sheet, [].slice.call(nextSheet.childNodes));
    cta.innerHTML = nextCta.innerHTML;
    title.innerHTML = nextTitle.innerHTML;
    CHECKOUT_HTML = cta.innerHTML;

    open.forEach(function(id) {
      var t = root.querySelector('[data-az-discount-toggle][aria-controls="' + id + '"]'), el = document.getElementById(id);
      if (t && el) { t.setAttribute('aria-expanded', 'true'); el.hidden = false; }
    });
    // 교체 중에 또 누른 줄은 보낼 수량을 계속 보여 줌
    Object.keys(qtyTargets).forEach(function(k) { setQtyDisplay(k, qtyTargets[k]); });
    if (focusSel) {
      var f = root.querySelector(focusSel + '[data-key="' + focusKey + '"]');
      if (f) f.focus();
    }
    // 금액이 서버 기준으로 바뀜 → 일부 선택 합계·배송 안내를 새 값으로 다시 계산
    selectionOriginal = null;
    shippingCache.clear();
    shippingSignature = '';
    refreshSummary();
  }

  // 최대 할인 자동 적용이 켜져 있으면 수량이 바뀐 카트로 다시 계산(새로고침 때 하던 일과 같음)
  function qtyBestSync(cart) {
    var az = window.azCoupon;
    if (!bestToggle || !az || !az.bestNeedsSync(cart, bestCandidateList())) return Promise.resolve(cart);
    // 포인트 사용 중 계산은 포인트 보호 절차가 길어 기존 경로(새로고침 후 계산)로
    if ((cart.discount_codes || []).some(function(d) { return pointIsPointCode(d.code); })) return Promise.reject(new Error('point best sync'));
    couponResolving = true;
    refreshSummary();
    return withTimeout(az.bestSync(cart, bestCandidateList(), false), 10000).then(function(b) {
      couponResolving = false;
      if (!b.changed) return cart;
      // Accept: application/json 을 붙이면 /cart 가 섹션 대신 장바구니 JSON 을 돌려줌 → 헤더 없이
      return withTimeout(fetch(window.location.pathname + '?sections=' + encodeURIComponent(qtySectionId))
        .then(function(res) {
          if (!res.ok) throw new Error('sections failed: ' + res.status);
          return res.json();
        }), QTY_TIMEOUT).then(function(s) {
        qtySwap(s[qtySectionId]);
        if (b.notice) showCouponNotice(b.notice);
        return b.cart || pointFetchCart();
      });
    });
  }

  function qtySend(cart) {
    var key = Object.keys(qtyTargets)[0];
    if (!key) return Promise.resolve(cart);
    var qty = qtyTargets[key];
    delete qtyTargets[key];
    return withTimeout(fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: qtySectionId, sections_url: window.location.pathname })
    }).then(function(res) {
      if (res.status === 422) alert(azT('alertQtyChangeFailed'));  // 재고 부족 등 — 안내 후 새로고침으로 실제 수량 표시
      if (!res.ok) throw new Error('change failed: ' + res.status);
      return res.json();
    }), QTY_TIMEOUT).then(qtySend);
  }

  function qtyLoop() {
    return qtySend(null).then(function(cart) {
      if (qtyCrossesNotice(qtyStartTotal, cart.total_price)) throw new Error('customs notice threshold');
      qtySwap(cart.sections && cart.sections[qtySectionId]);
      return qtyBestSync(cart);
    }).then(function(cart) {
      return Object.keys(qtyTargets).length ? qtyLoop() : cart;  // 반영하는 사이 또 누름 → 이어서
    });
  }

  function queueQty(key, qty) {
    // 다른 작업(쿠폰·포인트 처리, 로드 직후 잠금) 중이거나 섹션을 못 찾으면 기존 방식
    if (!qtyBusy && (couponBusy || couponResolving || window.azVipPointBusy || !qtySectionId || !window.DOMParser)) {
      changeLineQuantity(key, qty);
      return;
    }
    setQtyDisplay(key, qty);
    qtyTargets[key] = qty;
    if (qtyBusy) return;
    qtyBusy = true;
    couponBusy = true;      // 진행 중 쿠폰 조작이 카트를 동시에 바꾸지 않게
    pointReloading = true;  // 우리 요청 → 포인트 동기화 억제
    forgetKept();  // 고객이 카트를 직접 바꿈 → 예전 결제 때 뺀 상품 기록은 버림
    qtyStartTotal = Number((document.querySelector('[data-az-footer]') || root).getAttribute('data-cart-total')) || 0;
    refreshSummary();  // 결제 버튼 잠금
    qtyLoop().then(function(cart) {
      qtyBusy = false;
      couponBusy = false;
      pointReloading = false;
      pointBaselineSig = pointCartSig(cart);
      pointBaselineCount = cart.item_count;
      pointMaybeRenderRemove(cart);
      refreshSummary();
    }).catch(function(err) {
      log('qty err', err);
      qtyReload();
    });
  }

  root.addEventListener('click', function(e) {
    var upBtn = e.target.closest('[data-az-qty-up]');
    if (upBtn) {
      if (checkoutInFlight) return;
      var key = upBtn.getAttribute('data-key');
      var valEl = upBtn.parentElement.querySelector('[data-az-qty-value]');
      var cur = parseInt(valEl.textContent, 10) || 0;
      queueQty(key, cur + 1);
      return;
    }

    var downBtn = e.target.closest('[data-az-qty-down]');
    if (downBtn) {
      if (downBtn.disabled || checkoutInFlight) return;
      var key2 = downBtn.getAttribute('data-key');
      var valEl2 = downBtn.parentElement.querySelector('[data-az-qty-value]');
      var cur2 = parseInt(valEl2.textContent, 10) || 0;
      if (cur2 <= 1) return;
      queueQty(key2, cur2 - 1);
      return;
    }

    var delBtn = e.target.closest('[data-az-delete]');
    if (delBtn) {
      var delKey = delBtn.getAttribute('data-key');
      if (!confirm(azT('confirmDeleteOne'))) return;
      changeLineQuantity(delKey, 0);
      return;
    }
  });

  // ============================================================
  // 선택 삭제
  // ============================================================

  if (deleteSelectedBtn) {
    deleteSelectedBtn.addEventListener('click', function() {
      var selected = getCurrentSelected();
      if (selected.length === 0) {
        alert(azT('alertSelectToDelete'));
        return;
      }
      if (!confirm(azT('confirmDeleteSelected', { count: selected.length }))) return;

      var updates = {};
      selected.forEach(function(key) { updates[key] = 0; });
      forgetKept();

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('update failed');
        return res.json();
      })
      .then(function() { pointReloading = true; window.location.reload(); })
      .catch(function(err) {
        log('delete-selected err', err);
        alert(azT('alertDeleteFailed'));
      });
    });
  }

  // ============================================================
  // 쿠폰
  // ============================================================

  var couponForm = document.querySelector('[data-az-coupon-form]');
  var couponInput = document.querySelector('[data-az-coupon-input]');
  var couponError = document.querySelector('[data-az-coupon-error]');
  // 적용/해제 진행 중 연타 방지. 해제는 GET+POST 비동기 구간이 있어 연타 시
  // clear/재적용 체인이 경합해 쿠폰이 유실될 수 있다. 내비게이션하지 않고 끝나는
  // 분기에서만 false로 되돌린다(내비게이션하면 페이지가 갈리므로 불필요).
  var couponBusy = false;

  // 적용 처리 중 표시 — 버튼 스피너 + 입력·카드 잠금(한 번의 리로드까지 "처리 중"임을 보여 줌)
  function setCouponLoading(on) {
    var submit = document.querySelector('[data-az-coupon-submit]');
    if (submit) {
      if (on) {
        submit.setAttribute('data-label', submit.textContent);
        submit.innerHTML = '<span class="az-checkout-spinner" aria-hidden="true"></span>' + CHECKOUT_LOADING_TEXT;
      } else if (submit.hasAttribute('data-label')) {
        submit.textContent = submit.getAttribute('data-label');
      }
      submit.disabled = on || !couponInput || !couponInput.value.trim();
    }
    if (couponInput) couponInput.readOnly = on;
    [].slice.call(document.querySelectorAll('[data-az-coupon-toggle]')).forEach(function(b) {
      b.setAttribute('aria-busy', on ? 'true' : 'false');
    });
  }

  function applyDiscount(code) {
    var trimmed = (code || '').trim();
    if (!trimmed) return;
    if (couponBusy || window.azVipPointBusy) return;  // 해제/적용 진행 중 → 무시(경합 방지)
    couponBusy = true;
    couponResolving = true;  // 코드 목록 변경 중 → 결제 잠금
    pointReloading = true;   // 곧 리로드/이동 → 포인트 동기화 억제
    refreshSummary();
    setCouponLoading(true);
    var returnTo = window.location.pathname;

    // /discount/코드 단일 방문 = Shopify가 기존 코드에 merge 하고, 병용 불가면 유리한 쪽을 적용.
    // 콤마 다중코드 URL(/discount/A,B)은 이 스토어에서 통째로 무효 → 반드시 단일로 넘긴다.
    // 적용 전 코드 목록을 기록 → 리로드 후 azCoupon.resolve 가 결과를 안내. (포인트 사용 중·폴백 경로)
    function go() {
      window.location.href = '/discount/' + encodeURIComponent(trimmed) + '?redirect=' + encodeURIComponent(returnTo);
    }
    function viaDiscountUrl() {
      // 이동 전에 도중 변경분(복원 마커)을 먼저 되돌림 — 안 하면 돌아온 뒤 복원이 방금 적용한 쿠폰까지 지움
      window.azCoupon.recoverPending().then(function() {
        return window.azCoupon.recordAttempt(trimmed);
      }).then(go, go);
    }
    if (!window.azCoupon) { go(); return; }

    // 기본: 이동 없이 적용+판정 → 결과를 담아 한 번만 리로드
    window.azCoupon.applyInPlace(trimmed).then(function(res) {
      if (res.fallback) { viaDiscountUrl(); return; }
      window.azCoupon.saveNotice(res.notice);
      window.location.reload();
    }).catch(function() {
      viaDiscountUrl();  // 요청 실패 → 기존 이동 방식(복원 마커가 있으면 다음 로드에서 먼저 복원)
    });
  }

  function refreshCouponInputButton() {
    var button = document.querySelector('[data-az-coupon-submit]');
    if (button) button.disabled = couponBusy || (couponInput && couponInput.readOnly) || !couponInput || !couponInput.value.trim();
  }
  if (couponInput) {
    couponInput.addEventListener('input', refreshCouponInputButton);
    couponInput.addEventListener('change', refreshCouponInputButton);
    refreshCouponInputButton();
  }
  if (couponForm) {
    couponForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (couponError) couponError.hidden = true;
      var code = couponInput ? couponInput.value : '';
      if (!code.trim()) {
        if (couponError) {
          couponError.textContent = azT('couponEmpty');
          couponError.hidden = false;
        }
        return;
      }
      applyDiscount(code);
    });
  }

  // 특정 쿠폰 하나만 해제 — /cart/update.js 로 남길 코드 목록을 지정(목록 정확히 교체, 실측 확인).
  // 단 포인트(VIP-POINT)가 있으면 목록 교체 시 포인트 코드까지 다시 지정하게 되므로
  // (포인트 코드 재적용은 위험), 그 경우엔 파괴 없이 안내만 한다.
  function removeDiscountCode(codeToRemove) {
    var target = (codeToRemove || '').toLowerCase();
    if (!target) return;  // 코드 식별 불가 → 아무것도 안 함(실수로 전체 clear 방지)
    if (couponBusy || window.azVipPointBusy) return;  // 진행 중 연타 → 무시(clear/재적용 체인 경합 방지)
    couponBusy = true;
    pointReloading = true;  // 곧 reload → 포인트 동기화 억제
    pointFetchCart().then(function(cart) {
      var applied = pointGatherAppliedCodes(cart);
      if (applied.some(pointIsPointCode)) {
        // 포인트 적용 중 → 개별 해제 불가. 포인트·다른 쿠폰 보존 위해 파괴 없이 안내만.
        var perr = document.querySelector('[data-az-coupon-error]');
        if (perr) {
          perr.textContent = azT('point_individual_block');
          perr.hidden = false;
        }
        pointReloading = false;  // 이동/리로드 안 함 → 포인트 동기화 재개
        couponBusy = false;
        return;
      }
      // 해당 코드 하나만 뺀다 — 적용 대기 중인 코드(병용 불가로 밀린 직접 입력 코드 등)도 유지.
      // (적용 중 코드만 남기면 대기 중이던 고객 코드가 사라지고, 최대할인 재계산에서 자동 코드로 잘못 기록됨)
      var allCodesNow = (cart.discount_codes || []).map(function(d) { return d.code; }).filter(Boolean);
      applied.forEach(function(c) { if (allCodesNow.map(function(x) { return x.toLowerCase(); }).indexOf(c.toLowerCase()) === -1) allCodesNow.push(c); });
      var keep = allCodesNow.filter(function(c) { return c.toLowerCase() !== target; });
      // keep 이 비면 discount:'' → 전부 해제.
      // 최대할인 토글이 넣은 코드면 제외 목록에 기록 → 다시 자동으로 넣지 않음
      var bestAttrs = window.azCoupon ? window.azCoupon.bestRemovalAttrs(cart, codeToRemove, bestCandidateList()) : null;
      var hasRemainingCoupon = keep.some(function(code) { return !pointIsPointCode(code); });
      if (!hasRemainingCoupon) bestAttrs = Object.assign({}, bestAttrs || {}, {_az_best_coupon:'off', _az_best_codes:'', _az_best_sig:''});
      var bestOn = hasRemainingCoupon && !!(bestToggle && window.azCoupon && bestToggle.getAttribute('aria-checked') === 'true');
      function reload() { window.location.reload(); }
      pointSetDiscountCodes(keep, bestAttrs)
        .then(function() {
          // 토글 켜짐: 해제로 자리가 생겼으니 남은 후보로 바로 재계산(밀려 있던 기획전 쿠폰 복귀) → 리로드 1회
          if (!bestOn) return;
          return pointFetchCart().then(function(c2) {
            return window.azCoupon.bestSync(c2, bestCandidateList(), true);
          });
        })
        .then(reload, reload);
    }).catch(function() {
      // 카트 조회 실패 → 포인트/다른 쿠폰 유무를 모르는 상태. 파괴적 폴백(전체 clear) 대신
      // 아무것도 바꾸지 않고 재시도 안내만(포인트 보호 원칙과 일관).
      var perr = document.querySelector('[data-az-coupon-error]');
      if (perr) {
        perr.textContent = azT('coupon_remove_failed');
        perr.hidden = false;
      }
      pointReloading = false;
      couponBusy = false;
    });
  }

  document.addEventListener('click', function(e) {
    var toggleBtn = e.target.closest('[data-az-coupon-toggle]');
    if (toggleBtn && !toggleBtn.disabled) {
      var code = toggleBtn.getAttribute('data-code');
      var isApplied = toggleBtn.getAttribute('data-applied') === 'true';
      trackItemLater({ coupon_kind: trackCouponKind(code), state: isApplied ? 'off' : 'on' });
      if (isApplied) {
        removeDiscountCode(code);
      } else {
        applyDiscount(code);
      }
      return;
    }

    var removeBtn = e.target.closest('[data-az-coupon-remove]');
    if (removeBtn) {
      e.preventDefault();
      trackItemLater({ coupon_kind: trackCouponKind(removeBtn.getAttribute('data-code')), state: 'off' });
      removeDiscountCode(removeBtn.getAttribute('data-code'));
    }
  });

  // ============================================================
  // 포인트 적용 감지 → 명세서 갱신 (VIP use-point-form 대응)
  // - VIP 포인트 폼은 AJAX로 할인코드(VIP-POINT-*)를 카트에 적용하지만
  //   페이지를 리로드하지 않아, 서버 렌더된 금액 명세서가 stale 상태로 남음.
  //   카트 할인 변동을 감지해 reload로 갱신한다.
  // - 트리거: fetch/XHR 인터셉트(렌더 방식·shadow DOM 무관) + 포인트 폼 클릭(보조).
  // - 수량/삭제/쿠폰/결제 등 우리 액션은 자체 navigate/reload 하므로
  //   pointReloading 플래그로 그동안 포인트 동기화를 억제(이중 네비게이션 방지).
  // ============================================================

  var POINT_POLL_INTERVAL = 500;   // ms
  var POINT_POLL_MAX = 20;         // 최대 ≈10s (앱 프록시 지연 대비)
  var POINT_RELOAD_KEY = 'az_point_reloads';
  // 카트 변동 의심 URL (자체 /cart.js GET은 별도 제외)
  // /apps/(앱 프록시)는 카트 무관 앱 요청까지 잡아 불필요한 폴링을 유발하므로 제외.
  // VIP 포인트 적용은 트리거 B(포인트 폼 click/change/Enter)가 잡는다.
  var POINT_MUTATING = /\/(cart\/(add|update|change)|discount)(\.js|\/|\?|$)/i;

  function pointCartSig(cart) {
    // total_price + total_discount → 통화/라인레벨 무관, 적용·변경·해제 양방향 감지
    return cart.total_price + '|' + cart.total_discount;
  }

  function pointFetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(res) { return res.json(); });
  }

  function pointIsMutatingUrl(url) {
    return !!url && POINT_MUTATING.test(url) && !/\/cart\.js(\?|$)/.test(url);
  }

  // 무한 리로드 방지: 5초 내 3회 이상 리로드면 중단(루프 의심).
  // 정상 연속 조작(적용→해제→재적용)은 사이클당 수 초라 통상 걸리지 않음.
  function pointReloadGuardOk() {
    try {
      var now = Date.now();
      var raw = sessionStorage.getItem(POINT_RELOAD_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      arr = arr.filter(function(t) { return now - t < 5000; });
      if (arr.length >= 3) return false;
      arr.push(now);
      sessionStorage.setItem(POINT_RELOAD_KEY, JSON.stringify(arr));
      return true;
    } catch (e) { return true; }
  }

  function pointDoReload() {
    if (pointReloading || window.azVipPointBusy) return;
    if (!pointReloadGuardOk()) { log('point reload suppressed (loop guard)'); return; }
    pointReloading = true;
    log('point discount changed -> reload');
    window.location.reload();
  }

  // 새로 생긴 "적용 실패" 포인트 코드(VIP-POINT-*, applicable:false, 로드 시점엔 없던 것) 탐색
  function pointFindNewFailedCode(cart) {
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      var d = codes[i];
      if (d && d.code && pointIsPointCode(d.code) && d.applicable === false &&
          !pointSeenPointCodes[d.code.toLowerCase()]) {
        return d.code;
      }
    }
    return null;
  }

  // 포인트 적용 실패 안내를 포인트 폼 영역에 표시
  function pointShowApplyError(msg) {
    var wrap = root.querySelector('.az-vip-block--point-form');
    if (!wrap || document.querySelector("[data-vip-point-apply]")) return;
    var container = wrap.closest('.az-discount-item') || wrap.parentNode;
    if (!container) return;
    var el = container.querySelector('[data-az-point-error]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'az-discount-item__notice az-point-error';
      el.setAttribute('data-az-point-error', '');
      el.style.color = '#c0392b';
      container.appendChild(el);
    }
    el.textContent = msg;
    el.hidden = false;
  }

  // 포인트 적용으로 기존(로드 시점) 쿠폰이 밀려났으면 → 리로드 후 안내하도록 기록
  function pointFlagKnockedCoupon(cart) {
    var nowActive = pointGatherAppliedCodes(cart).map(function(c) { return c.toLowerCase(); });
    if (!nowActive.some(pointIsPointCode)) return;  // 포인트가 적용된 경우만(포인트가 이긴 상황)
    for (var i = 0; i < pointBaselineCoupons.length; i++) {
      if (nowActive.indexOf(pointBaselineCoupons[i].toLowerCase()) === -1) {  // 있던 쿠폰이 사라짐
        try { sessionStorage.setItem(POINT_COUPON_KNOCKED_KEY, pointBaselineCoupons[i]); } catch (e) {}
        return;
      }
    }
  }

  // 포인트가 쿠폰을 밀어낸 경우 안내(리로드 후). 다른 안내가 이미 떠 있으면 건너뜀.
  function pointCheckKnockedCoupon() {
    var knocked = null;
    try { knocked = sessionStorage.getItem(POINT_COUPON_KNOCKED_KEY); } catch (e) {}
    if (!knocked) return;
    try { sessionStorage.removeItem(POINT_COUPON_KNOCKED_KEY); } catch (e) {}
    var couponErr = document.querySelector('[data-az-coupon-error]');
    if (!couponErr || !couponErr.hidden) return;  // 요소 없거나 이미 다른 안내 표시중 → 건너뜀
    couponErr.textContent = azT('coupon_knocked_by_point', { code: knocked });
    couponErr.hidden = false;
  }

  function pointStartPoll() {
    if (pointPolling || pointReloading || window.azVipPointBusy || pointBaselineSig === null) return;
    pointPolling = true;
    var tries = 0;
    (function tick() {
      tries++;
      pointFetchCart().then(function(cart) {
        if (pointCartSig(cart) !== pointBaselineSig) {
          pointPolling = false;
          pointFlagKnockedCoupon(cart);  // 포인트가 기존 쿠폰을 밀어냈으면 리로드 후 안내하도록 기록
          pointDoReload();  // 할인 변동(포인트/쿠폰 적용·해제) → 명세서 갱신
          return;
        }
        // 변동 없음 → 새로 실패한 포인트 코드가 생겼으면(결합 불가 등으로 적용 거부) 안내
        var failed = pointFindNewFailedCode(cart);
        if (failed) {
          pointPolling = false;
          pointSeenPointCodes[failed.toLowerCase()] = true;  // 재표시 방지
          pointShowApplyError(azT('point_apply_failed'));
          return;
        }
        if (tries >= POINT_POLL_MAX) { pointPolling = false; return; }  // 진짜 무변동 → 조용히 종료
        setTimeout(tick, POINT_POLL_INTERVAL);
      }).catch(function() { pointPolling = false; });
    })();
  }

  // ── 적용된 할인코드 수집 / VIP 포인트 코드 식별 ──
  function pointGatherAppliedCodes(cart) {
    var codes = [];
    (cart.discount_codes || []).forEach(function(d) {
      if (d && d.applicable && d.code && codes.indexOf(d.code) === -1) codes.push(d.code);
    });
    (cart.cart_level_discount_applications || []).forEach(function(a) {
      if (a && a.type === 'discount_code' && a.title && codes.indexOf(a.title) === -1) codes.push(a.title);
    });
    // 제품 할인(amount off products)은 위 두 소스에 안 잡히고 아이템별 line-level에만 있음.
    // 여기서 누락하면 재적용(keep) 시 기존 제품 쿠폰이 빠져 유실됨 → "하나만 적용" 증상.
    // 단 자동/스크립트 할인은 코드가 없어 /discount/로 재적용 불가하므로 discount_code 타입만 수집.
    (cart.items || []).forEach(function(item) {
      (item.line_level_discount_allocations || []).forEach(function(al) {
        var app = al && al.discount_application;
        if (app && app.type === 'discount_code' && app.title && codes.indexOf(app.title) === -1) {
          codes.push(app.title);
        }
      });
    });
    return codes;
  }

  function pointIsPointCode(code) {
    return /VIP-?POINT/i.test(code || '');
  }

  // 카트의 할인코드 목록을 정확히 지정 — /cart/update.js {discount:'A,B'} (공식 Ajax API, 실측 확인).
  // 빈 배열이면 전부 해제. (/discount/A,B 콤마 URL 과 달리 이 API 는 목록 지정이 동작한다)
  function pointSetDiscountCodes(codes, attrs) {
    var payload = { discount: codes.join(',') };
    if (attrs) payload.attributes = attrs;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(res) {
      if (!res.ok) throw new Error('discount update failed: ' + res.status);
      return res.json();
    });
  }

  // 포인트 사용 취소 — VIP-POINT 코드만 빼고 쿠폰 등 나머지는 그대로 목록 지정(포인트 코드는 재지정 안 함).
  function removePointDiscount() {
    if (couponBusy || window.azVipPointBusy) return;  // 쿠폰 적용/해제 진행 중 연타 → 무시(경합 방지)
    couponBusy = true;       // 이하 모든 분기가 reload로 끝나므로 리셋 불필요
    pointReloading = true;
    function done() { window.location.reload(); }
    pointFetchCart().then(function(cart) {
      // 포인트만 뺀다 — 포인트에 밀려 대기 중이던 쿠폰(자동 적용분 포함)도 유지.
      // 최대할인 서명을 비워 다음 로드에 다시 계산(포인트가 빠져 기획전 쿠폰이 다시 이길 수 있음)
      var all = (cart.discount_codes || []).map(function(d) { return d.code; }).filter(Boolean);
      pointGatherAppliedCodes(cart).forEach(function(c) {
        if (all.map(function(x) { return x.toLowerCase(); }).indexOf(c.toLowerCase()) === -1) all.push(c);
      });
      var keep = all.filter(function(c) { return !pointIsPointCode(c); });
      return pointSetDiscountCodes(keep, bestToggle ? { _az_best_sig: '' } : null);
    }, function() {
      return pointSetDiscountCodes([]);  // 카트 조회 실패 → 포인트 확실히 제거(쿠폰은 다시 적용 필요)
    }).then(done, done);
  }

  // 포인트가 적용돼 있으면 "포인트 사용 취소" 버튼을 폼 영역에 주입(중복 방지).
  function pointMaybeRenderRemove(cart) {
    var hasPoint = pointGatherAppliedCodes(cart).some(pointIsPointCode);
    var wrap = root.querySelector('.az-vip-block--point-form');
    if (!wrap || document.querySelector("[data-vip-point-apply]")) return;
    var container = wrap.closest('.az-discount-item') || wrap.parentNode;
    if (!container) return;
    var existing = container.querySelector('[data-az-point-remove]');
    if (hasPoint && !existing) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'az-link-btn az-point-remove';
      btn.setAttribute('data-az-point-remove', '');
      btn.textContent = azT('point_cancel_button');
      container.appendChild(btn);
    } else if (!hasPoint && existing) {
      existing.remove();
    }
  }

  // 카트 코드 목록에 남아 있으나 장바구니에서는 적용 여부를 알 수 없는 코드(applicable:false, 포인트 제외) —
  // 배송비 쿠폰은 결제 단계에서야 판정되므로 이 상태로 남는다(2026-10-06 layered-jewelry 실측).
  // 무료배송을 단정하지 않고 「쿠폰 입력됨 · 구매절차에서 확인」 으로만 표시. 조건 미충족 일반 쿠폰도 같은 상태일 수 있음.
  // 쿠폰 적용 결과 안내(azCoupon.resolve 의 notice) — 쿠폰 입력칸 아래 안내 슬롯에 표시.
  // info(교체·병용 불가 안내)는 중립색, error(적용 불가)는 빨간색. switchCode 가 있으면 교체 버튼 제공.
  // 다른 안내(포인트가 쿠폰을 밀어냄 등)가 이미 떠 있으면 양보.
  function showCouponNotice(notice) {
    if (!notice || !notice.text) return;
    var el = document.querySelector('[data-az-coupon-error]');
    if (!el) { if (window.azCoupon) window.azCoupon.toast(notice.text); return; }  // 빈 카트 등 쿠폰 영역 없음
    if (!el.hidden) return;
    el.textContent = notice.text;
    el.classList.toggle('az-coupon__error--info', notice.type === 'info');
    if (notice.switchCode) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'az-link-btn az-coupon__switch';
      btn.setAttribute('data-az-coupon-switch', notice.switchCode);
      btn.textContent = azT('switch_button', { code: notice.switchCode });
      el.appendChild(document.createTextNode(' '));
      el.appendChild(btn);
    }
    el.hidden = false;
  }

  // ── 최대 할인 자동 적용 토글 ──
  // 후보 없음(회색 토글): 켜지지 않음. 탭하면 기록만(리로드 없음, 2초 안 연타는 1회)
  var bestDisabled = document.querySelector('[data-az-best-toggle-disabled]');
  if (bestDisabled) {
    var bestDisabledAt = 0;
    bestDisabled.addEventListener('click', function() {
      if (Date.now() - bestDisabledAt < 2000) return;
      bestDisabledAt = Date.now();
      var s = trackState();
      track('az_coupon_toggle', { state: 'off', result_state: 'none_available', total_before: s.cart_total, total_after: s.cart_total, coupon_count_before: s.applied_coupon_count, coupon_count_after: s.applied_coupon_count });
    });
  }
  var bestToggle = document.querySelector('[data-az-best-toggle]');
  function bestCandidateList() {
    var raw = bestToggle ? bestToggle.getAttribute('data-candidates') : '';
    return raw ? raw.split(',').map(function(c) { return c.trim(); }).filter(Boolean) : [];
  }
  function showBestNote(text) {
    var el = document.querySelector('[data-az-best-note]');
    if (!el) return;
    el.textContent = text;
    el.hidden = !text;
  }
  if (bestToggle) {
    bestToggle.addEventListener('click', function() {
      if (couponBusy || window.azVipPointBusy || !window.azCoupon) return;
      couponBusy = true;
      couponResolving = true;
      pointReloading = true;
      refreshSummary();
      bestToggle.setAttribute('aria-busy', 'true');
      var turnOn = bestToggle.getAttribute('aria-checked') !== 'true';
      var before = trackState();
      try { sessionStorage.setItem(TRACK_TOGGLE_KEY, JSON.stringify({ state: turnOn ? 'on' : 'off', total_before: before.cart_total, coupon_count_before: before.applied_coupon_count, t: Date.now() })); } catch (e) {}
      // 스위치는 즉시 반영(체감 반응), 실제 결과는 리로드 후 서버 렌더
      bestToggle.classList.toggle('is-on', turnOn);
      bestToggle.setAttribute('aria-checked', String(turnOn));
      function done(res) {
        if (res && res.notice) window.azCoupon.saveNotice(res.notice);
        window.location.reload();
      }
      window.azCoupon.bestSetEnabled(turnOn, bestCandidateList()).then(done, function(error) { console.warn('VIP coupon toggle:', error.message); window.location.reload(); });
    });
  }

  // 병용 불가로 밀린 쿠폰으로 교체
  document.addEventListener('click', function(e) {
    var sw = e.target.closest('[data-az-coupon-switch]');
    if (!sw || !window.azCoupon) return;
    e.preventDefault();
    if (couponBusy || window.azVipPointBusy) return;
    couponBusy = true;
    pointReloading = true;
    function done() { window.location.reload(); }
    window.azCoupon.switchTo(sw.getAttribute('data-az-coupon-switch')).then(done, done);
  });

  // 포인트 취소 버튼 클릭 (쿠폰 리스너와 별개)
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-az-point-remove]')) {
      e.preventDefault();
      removePointDiscount();
    }
  });

  // baseline 캡처 (현재 서버 카트 = SSR 반영값). 이후 변동분만 감지 대상.
  // + 포인트 적용 상태면 취소 버튼 주입. 실패 시 재시도(baseline null이면 감지 비활성).
  function pointCaptureBaseline(attempt) {
    // 처리할 쿠폰 시도가 있으면 resolve 가 코드 목록을 잠시 바꿀 수 있음(probe) →
    // 끝날 때까지 결제·쿠폰 조작을 잠가 "기존 쿠폰이 빠진 채 결제 진행"을 막는다.
    var az = window.azCoupon;
    var locking = !!(az && (az.hasAttempt() || bestToggle));
    if (locking) {
      couponResolving = true;
      couponBusy = true;
      pointReloading = true;
      refreshSummary();
    }
    function unlock() {
      if (!locking) return;
      couponResolving = false;
      couponBusy = false;
      pointReloading = false;
      refreshSummary();  // 선택 개수 기준으로 결제 버튼 상태 복원
      // 잠금 중 VIP 포인트가 적용됐으면 감지(잠금 동안엔 폴링이 억제됨) — 1회만 확인(반복 폴링은 요청 폭주·429 유발)
      if (pointBaselineSig !== null) {
        pointFetchCart().then(function(c) {
          if (pointCartSig(c) !== pointBaselineSig) { pointFlagKnockedCoupon(c); pointDoReload(); }
        }).catch(function() {});
      }
    }
    pointFetchCart().then(function(cart) {
      // 쿠폰 적용 시도 결과 해석(교체·병용 불가·조건 미충족). 카트 코드 목록을 정리했으면 다시 그리기 위해 리로드.
      var resolving = az ? az.resolve(cart) : Promise.resolve({ changed: false, notice: null });
      return resolving.then(function(res) {
        // 최대 할인 자동 적용: 후보·카트 구성이 바뀌었을 때만 다시 계산(같으면 즉시 통과)
        if (res.changed || !bestToggle || !az) return res;
        if (!az.bestNeedsSync(cart, bestCandidateList())) return res;
        // 실패하면 카트가 반쯤 바뀌었을 수 있음 → 리로드해 복원 마커로 원상 복구. 10초 넘게 걸리면 같은 처리.
        var timeout = new Promise(function(resolve) {
          setTimeout(function() { resolve({ changed: true, notice: null }); }, 10000);
        });
        var sync = az.bestSync(cart, bestCandidateList(), false).then(function(b) {
          return b.changed ? { changed: true, notice: b.notice || res.notice } : res;
        }, function() { return { changed: true, notice: null }; });
        // SDK 취소·재발급 중에는 중간 상태에서 리로드하지 않는다.
        return (cart.discount_codes || []).some(function(d){return pointIsPointCode(d.code);}) ? sync : Promise.race([sync, timeout]);
      }).then(function(res) {
        if (res.changed) {
          az.saveNotice(res.notice);
          pointReloading = true;
          window.location.reload();
          return;
        }
        pointBaselineSig = pointCartSig(cart);
        pointBaselineCount = cart.item_count;
        // 로드 시점의 포인트 코드를 "기존"으로 기록 → 이후 새로 실패한 코드만 안내
        (cart.discount_codes || []).forEach(function(d) {
          if (d && d.code && pointIsPointCode(d.code)) pointSeenPointCodes[d.code.toLowerCase()] = true;
        });
        // 로드 시점에 적용 중이던 쿠폰(비포인트) 기록 → 포인트가 이를 밀어냈는지 감지
        pointBaselineCoupons = pointGatherAppliedCodes(cart).filter(function(c) { return !pointIsPointCode(c); });
        pointMaybeRenderRemove(cart);
        pointCheckKnockedCoupon();  // 더 구체적인 안내 우선
        showCouponNotice(res.notice || (az && az.takeNotice()));  // 이미 안내가 떠 있으면 양보
        unlock();
      });
    }).catch(function() {
      unlock();
      if ((attempt || 0) < 3) {
        setTimeout(function() { pointCaptureBaseline((attempt || 0) + 1); }, 1000);
      }
    });
  }
  // (시작은 파일 끝 init 이후 — 세트/부속 줄 잠금 등 초기 상태가 잡힌 뒤)

  // 트리거 A: fetch 인터셉트 (원본 호출/반환 그대로 통과, 관찰만)
  // ⚠️ cart-notification.js도 window.fetch를 래핑함(공존). 두 래퍼 모두
  //    "원본 promise를 변형 없이 반환 + 관찰만(응답 body 미접근)" 규약을 지켜야 충돌이 없다.
  if (typeof window.fetch === 'function') {
    var pointOrigFetch = window.fetch;
    window.fetch = function(input) {
      var p = pointOrigFetch.apply(window, arguments);
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        if (pointIsMutatingUrl(url)) {
          p.then(function() { pointStartPoll(); }, function() {});
        }
      } catch (e) {}
      return p;
    };
  }

  // 트리거 A': XHR 인터셉트 (VIP/jQuery가 XHR을 쓸 경우 대비)
  (function() {
    var XHR = window.XMLHttpRequest;
    if (!XHR || !XHR.prototype) return;
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;
    XHR.prototype.open = function(method, url) {
      this.__azPointUrl = url;
      return origOpen.apply(this, arguments);
    };
    XHR.prototype.send = function() {
      try {
        if (pointIsMutatingUrl(this.__azPointUrl)) {
          this.addEventListener('loadend', function() { pointStartPoll(); }, { once: true });
        }
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
  })();

  // 트리거 B: 포인트 폼 상호작용 (capture phase → shadow DOM 경계 통과)
  function onPointFormInteraction(e) {
    if (pointReloading || window.azVipPointBusy) return;
    var t = e.target;
    if (t && t.closest && t.closest('.az-vip-block--point-form')) pointStartPoll();
  }
  root.addEventListener('click', onPointFormInteraction, true);
  root.addEventListener('change', onPointFormInteraction, true);  // 입력 변경(blur 적용형) 대비
  root.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') onPointFormInteraction(e);
  }, true);

  // ============================================================
  // 결제 진행 — 미체크 상품은 카트에서 제거 후 /checkout
  // (v1.6) 진행 중 잠금: 이중 제출·진행 중 선택/수량 변경 차단. 결제 직전 금액 재확인 창은 두지 않음 —
  //   결제 화면이 최종 금액 확인 단계이고, 단계를 늘리면 이탈이 늘어남(사용자 결정). 화면 금액은 선택 합계 + 안내.
  // ============================================================

  var checkoutInFlight = false;

  function setCheckoutLock(on) {
    checkoutInFlight = on;
    root.classList.toggle('is-checkout-locked', on);
    // 키보드 조작까지 차단(pointer-events 만으로는 Tab/Enter 로 수량 버튼 등을 누를 수 있음)
    [].slice.call(root.querySelectorAll('.az-cart__select-bar, .az-cart__items, .az-discount-group, .az-order-note'))
      .forEach(function(el) { el.inert = on; });
    if (!checkoutBtn) return;
    if (on) checkoutBtn.disabled = true;
    else refreshSummary();  // 선택 상태 기준으로 버튼 복원 (뒤로가기 복원 시 버튼이 죽은 채 남지 않게)
  }

  function withTimeout(promise, ms) {
    return Promise.race([promise, new Promise(function(_, reject) {
      setTimeout(function() { reject(new Error('timeout')); }, ms);
    })]);
  }

  function lineInfo(key) {
    var item = root.querySelector('[data-az-item][data-key="' + key + '"]');
    var a = item && item.querySelector('[data-az-line-amounts]');
    if (!a) return null;
    var line = { id: parseInt(a.getAttribute('data-variant'), 10), quantity: parseInt(a.getAttribute('data-qty'), 10) || 1 };
    try {
      var props = JSON.parse(a.getAttribute('data-properties') || 'null');
      if (props && typeof props === 'object' && Object.keys(props).length) line.properties = props;
    } catch (e) {}
    var plan = parseInt(a.getAttribute('data-plan'), 10);
    if (plan) line.selling_plan = plan;
    return line.id ? line : null;
  }
  // 뺄 줄 + 결제에 남는 같은 옵션·속성 줄의 수량(keep) — 돌아왔을 때 "빠진 만큼만" 다시 담기 위해
  function collectKept(removeKeys, keepKeys) {
    function sig(l) { return l.id + '|' + JSON.stringify(l.properties || {}) + '|' + (l.selling_plan || 0); }
    var kept = {};
    keepKeys.map(lineInfo).filter(Boolean).forEach(function(l) { kept[sig(l)] = (kept[sig(l)] || 0) + l.quantity; });
    return removeKeys.map(lineInfo).filter(Boolean).map(function(l) { l.keep = kept[sig(l)] || 0; return l; });
  }

  // 결제 시 뺐던 미선택 상품이 남아 있으면 다시 담고 새로고침 → true (호출 측은 나머지 시작을 건너뜀)
  function forgetKept() {
    if (window.azCoupon) window.azCoupon.saveKept([]);
  }

  // 다시 담기가 끝날 때까지 잠금 → 바뀌었거나 실패했으면 리로드(실패는 다음 로드에서 한 번 더 시도),
  // 담을 게 없었으면 잠금만 풀고 onUnchanged
  function restoreKeptThenReload(onUnchanged) {
    if (!window.azCoupon || !window.azCoupon.hasKept()) return false;
    pointReloading = true;
    setCheckoutLock(true);
    window.azCoupon.restoreKept().then(function(r) {
      if (!r.changed && r.ok) {
        pointReloading = false;
        setCheckoutLock(false);
        if (onUnchanged) onUnchanged();
        return;
      }
      if (!r.ok && !r.retry) {
        try { sessionStorage.setItem('az_coupon_notice', JSON.stringify({ type: 'error', text: azT('restore_failed') })); } catch (e) {}
      }
      window.location.reload();
    });
    return true;
  }

  if (stickyForm) {
    stickyForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (checkoutInFlight) return;  // 이중 제출 방지
      var selected = getCurrentSelected();
      if (selected.length === 0) return;
      if (couponResolving || qtyBusy || window.azVipPointBusy) return;  // 쿠폰 결과 해석 중·수량 반영 중(코드 목록 변경 가능) → 끝난 뒤 진행
      var ts = trackState();
      track('az_checkout_click', { toggle_state: ts.toggle_state, cart_total: ts.cart_total, coupon_discount: ts.coupon_discount, applied_coupon_count: ts.applied_coupon_count, selected_all: selected.length === root.querySelectorAll('[data-az-select-item]').length });
      pointReloading = true;  // 곧 /checkout로 이동 → 포인트 동기화가 가로채지 않도록

      var allItems = [].slice.call(root.querySelectorAll('[data-az-item]'))
        .map(function(el) { return el.getAttribute('data-key'); });
      var toRemove = allItems.filter(function(k) { return selected.indexOf(k) === -1; });

      setCheckoutLock(true);
      // 통화 변환 스크립트가 로드 후 금액을 바꿨을 수 있음 → 스피너 직전 내용을 저장해 그대로 복원
      CHECKOUT_HTML = checkoutBtn.innerHTML;
      checkoutBtn.innerHTML = CHECKOUT_LOADING_HTML;

      if (toRemove.length === 0) {
        forgetKept();  // 전부 결제 → 예전 부분 결제의 기록이 남아 있으면 구매 후 다시 담기지 않게
        window.location.href = '/checkout';
        return;
      }

      var updates = {};
      toRemove.forEach(function(key) { updates[key] = 0; });
      // 뺀 미선택 상품 기록 → 스토어로 돌아오면 다시 담김(구매 후에도 카트에 남음). 제거 실패 시에도 다음 로드에서 정리됨
      if (window.azCoupon) window.azCoupon.saveKept(collectKept(toRemove, selected));

      withTimeout(fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }), 15000)
      .then(function(res) {
        if (!res.ok) throw new Error('update failed');
        window.location.href = '/checkout';
      })
      .catch(function(err) {
        log('checkout prep err', err);
        // 실패/타임아웃 → 제거가 늦게 반영됐을 수도 있으니 화면을 실제 카트 기준으로 다시 그림. 안내는 화면 안에(인앱 브라우저는 alert 를 막기도 함)
        try { sessionStorage.setItem('az_coupon_notice', JSON.stringify({ type: 'error', text: azT('checkout_prep_retry') })); } catch (e2) {}
        window.location.reload();
      });
    });
  }

  // ============================================================
  // 초기화: default 전체 선택
  // ============================================================

  function init() {
    if (selectAllInput) selectAllInput.checked = true;
    [].slice.call(root.querySelectorAll('[data-az-select-item]')).forEach(function(input) {
      input.checked = true;
      // 세트 상품·부속 상품 줄은 지웠다 다시 담으면 구조가 깨지므로 체크 해제 불가(항상 결제에 포함)
      var item = input.closest('[data-az-item]');
      var a = item && item.querySelector('[data-az-line-amounts]');
      if (a && a.getAttribute('data-complex') === 'true') input.disabled = true;
    });
    refreshSummary();
    trackPageLoad();
  }

  init();
  if (!restoreKeptThenReload(function() { pointCaptureBaseline(0); })) pointCaptureBaseline(0);
  log('initialized v1.4', { items: root.querySelectorAll('[data-az-item]').length });

})();

// Keep dynamically replaced coupon labels tied to the visible cart line title.
(function() {
  var queued = false;
  function syncProductLabels() {
    queued = false;
    var names = {};
    document.querySelectorAll('[data-az-item][data-key]').forEach(function(item) {
      var title = item.querySelector('.az-product__name');
      if (title) names[item.getAttribute('data-key')] = title.textContent.trim();
    });
    document.querySelectorAll('[data-detail-coupon-key] .az-purchase-detail__coupon-name, [data-az-product-name-key]').forEach(function(label) {
      var row = label.closest('[data-detail-coupon-key]');
      var key = label.getAttribute('data-az-product-name-key') || (row && row.getAttribute('data-detail-coupon-key'));
      if (!names[key]) return;
      if (label.getAttribute('translate') !== 'no') label.setAttribute('translate', 'no');
      if (label.textContent !== names[key]) label.textContent = names[key];
    });
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(syncProductLabels); }
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  syncProductLabels();
})();
